export default {
  addEmployee: "Add User",
  employees: "Users",
  employee_history: "Users lifecycle",
  searchInEmployees: "Search in Users",
  all: "All",
  activeEmployee: "Active",
  suspended: "Suspended",
  offBoarding: "Offboarding",
  onBoarding: "Onboarding",
  name: "Name",
  jobTitle: "Job title",
  employee_job_details: "User job details",
  job_details: "Job details",
  work_info: "Work info",
  work_model: "Work model",
  choose_work_type: "Choose work model",
  phoneNumber: "Phone number",
  country: "Country",
  state: "Province/state",
  city: "City",
  home_address: "Address",
  status: "Status",
  member: "member",
  employee_reporter: "User's reporter",
  members: "members",
  not_found: "User not found",
  choose_employee: "choose your user",
  search_select_employee: "Search & Select Your User",
  choose_existing: "Choose an existing user to onboard",
  create: "skip & create new user",
  go_to_integration: "To enroll users in bulk, go to",
  integration_tab: "the Integrations tab",
  integrations: "integrations",
  deleteConfirmation: "Delete Confirmation",
  areYouSureYouWantToDeleteThisEmployee: "Are you sure to delete this user?",
  assignDeviceToEmployee: "Assign device",
  completeJobDetails: "Complete job details",
  success: "Success",
  employeeUpdated: "User updated",
  editPersonalInfo: "Edit personal info",
  assignDevice: "Assign device",
  suspend: "Suspend",
  deleteOffboard: "Offboard",
  quickOffboard: "Quick offboard",
  select_employee: "Select user",
  activate: "Activate",
  companyOffboarding: "Continue offboarding",
  areYouSureYouWantSuspendThisUser:
    "Are you sure that you want to suspend the user?",
  cancel: "Cancel",
  confirmation: "Confirmation",
  edit_employee: "Edit user",
  select_device: "Select Device for",
  search_devices: "Search in Devices",
  search_in_devices: "Search in device name/os",
  search_in_accessories: "Search in Accessories",
  added_date: "Added date",
  of_3_assigned: "of 3 assigned",
  areYouSureYouWantToActiveThisUser:
    "Are you sure that you want to active the user?",
  active: "Active",
  actions: "Actions",
  deleteSuccessfully: "Delete successfully",
  device_assigned: "your device(s) assigned successfully",
  error: "Error",
  somethingWentWrong: "Something went wrong",
  updateSuccessfully: "Update successfully",
  devices: "Devices",
  applications: "Applications",
  noDeviceAssigned: "No assigned devices",
  unassignDevice: "Unassign Device",
  areYouSureYouWantToUnAssignDevice:
    "Are you sure you want to unassign this device?",
  deviceSuccessfulyUnassigned: "The device has been unassigned successfully",
  unnassigendsuccess: "Device unassigned!",
  unassign: "Unassign",
  manageDevice: "Manage device",
  model: "Model",
  deviceType: "Device type",
  operationSystem: "Operating system",
  processor: "Processor",
  memory: "Memory",
  diskSize: "Disk size",
  assignedApplications: "Assigned applications",
  allDevices: "All Devices",
  assignedTo: "Assigned to",
  department: "Autopilot",
  version: "Version",
  reporter: "Reporter",
  personal_email: "Personal email",
  company_email: "Company email",
  email: "Email",
  workEmail: "Work email",
  homePhoneNumber: "Home phone number",
  mobilePhoneNumber: "Mobile phone number",
  birthDate: "Date of birth",
  startDate: "Start date",
  workType: "Work model",
  office: "Office",
  contractType: "Contract type",
  address: "Address",
  list: "List",
  taskOverview: "Task Overview",
  onBoard: "Onboarding",
  offBoard: "Offboarding",
  transition: "Transition",
  toDo: "To Do",
  inProgress: "In Progress",
  scheduled: "Scheduled",
  deviceArrival: "Device arrival",
  employeeName: "User's name",
  description: "Description",
  lastStep: "Last step",
  actionOnEmployees: "Actions on Users",
  newOperation: "New Operation",
  newOnboard: "New onboard",
  quickAdd: "Quick add",
  addFromCSV: "Add from CSV",
  importFromGoogleWorkspace: "Import from Google Workspace",
  add_manually: "Add Manually",
  importFromOffice365: "Import from Microsoft Entra ID",
  continue_onboarding: "Continue onboarding",
  no_employee: "No user added yet",
  statuses: {
    ACTIVE: "Active",
    SUSPEND: "Suspended",
    UNVERIFIED: "Unverified",
    ONBOARD_INCOMPLETE_INFO: "Incomplete info",
    INCOMPLETE_INFO: "On-Board",
    ONBOARD_JOB_POSITION_NEEDED: "Job position needed",
    ONBOARD_APPS_NEEDED: "Apps needed",
    ONBOARD_ACCESSIBILITY_NEEDED: "Accessibility needed",
    ONBOARD_DEVICE_POLICY_NEEDED: "Device and Policy needed",
    ONBOARD_CONFIRM_NEEDED: "Confirm needed",
    OFFBOARD_DEVICE_AND_DATA: "Device and date",
    OFFBOARD_ACCESSIBILITY: "Accessibility",
    OFFBOARD_USER_ACCOUNT: "User account",
    DELETED: "Deleted",
  },
  import_employee: "Import Users",
  upload_your_csv: "Upload your CSV file to add multiple users at once",
  drag_drop_file: "Drag & Drop or browse to choose a file",
  only_csv_format: "Only CSV format supported (maximum 1 MB)",
  your_file_successfully: "Your file successfully uploaded",
  dont_have_template: "Don’t have template?",
  download_template: "Download Template",
  importing_employee: "Importing Users",
  we_are_adding_employee: "We’re adding users to Trio, it may take a while",
  employee_list_added: "User List Added Successfully",
  profile_photo: "Profile picture (Optional)",
  profile_photo_description: "Upload PNG or JPEG files under 2MB",
  choose_profile: "Click to select Profile picture",
  choose_user_image: "Drag or choose a profile pic.",
  personal_information: "Personal information",
  address_contact: "Address & Contact",
  email_business: "Business email",
  os: "OS",
  choose_group: "Choose a autopilot(optional)",
  fill_basic_employee: "Fill in basic user information",
  confirm_email: "Confirm this email?",
  change_email_warning:
    "You can NOT change this email address after it's created.",
  user_password: "User password",
  force_reset_pass: "Force password reset upon first login.",
  manage_apple_id: "Managed apple ID is same as business email address",
  drawerTitles: {
    csv: "Import CSV (Bulk Enroll)",
    googleWorkspace: "Import from Google Workspace",
    office365: "Import from Microsoft Entra ID",
    quickAdd: "Quick add user",
    quickaddGroup: "Quick add autopilot",
  },
  drawerGroupTitles: {
    addAutopilot: "Add Autopilot",
    quickaddAutopilot: "Quick add Autopilot",
  },
  quickAddGroup: "Quick add autopilot",
  group_title: "Add autopilot",
  group_description: "Create your autopilot simple and fast",
  import_from_google_wrokspace: {
    loading_title: "We’re receiving users list & info",
    loading_sub_title: "It may take a while, please wait...",
    not_connect_description:
      "Integrate Trio with {{serviceName}} for streamlined user account management.",
    attention: "Available to users on the Growth plan or higher.",
    tips: {
      one: "Provision or deprovision user accounts.",
      second: "provision or deprovision user accounts.",
      third: "Suspend accounts and restrict access.",
      fourth: "Optimize productivity with collaborative tools.",
    },
    warning:
      "By integrating with {{serviceName}}, you grant Trio the permission to handle your information in line with its Privacy Policy.",
    employees_list_title: {
      first_clue: "Choose users to import",
      second_clue: "({{number}} Found)",
    },
    confirmAndImport: "Confirm & import",
  },
  import_success_title: "Users imported successfully",
  import_success_sub_title: "{{imported}} Users added to your users’ list.",
  import_success: "Success",
  import_success_imported: "Imported users: {{imported}}",
  import_success_rejected: "Rejected users: {{rejected}}",
  onboard_summary: "On-board Summary",
  assignDeviceFirst: "Assign device first",
  emptyStateDescription:
    "This page show you applications that installed on devices",
  no_employee_found: "No user found",
  select_offboard: "Select active users for offboarding.",
  offboard_discard_notice:
    "Are you sure? By discarding this process you can no longer access this user’s offboarding data.",
  archive_trio: "Archive Trio account:",
  archive_user: "Archive user accounts:",
  trio_account: "Trio Account",
  no_employee_added_yet: "No users have been added yet.",
  no_users_group_added_yet: "No users group have been added yet.",
  add_first_employee: "Add first user",
  release: "Release",
  selectEmployee: "Select User",
  enteredBusinnessEmailIsSameWithAppleId:
    "The entered business email is the same as the user's Apple ID",

  assignDeviceToUser: "Assign a device to the user",
  addDevice: "Add",
  add_it_device: "Add IT asset",
  accessories: "Accessories",
  it_asset: "IT asset",
  it_asset_description: "Description of IT Asset",
  pick_device: "Pick a device to assign to the user",
  pick_accessories: "Pick accessories to assign to the user",
  noAccessories: "No accessories",
  noDevices: "No Devices",
  empty_devices:
    "The organization needs to register the devices first. After it's done, the devices will appear here.",
  empty_accessories:
    "The organization needs to register the accessories first. After it's done, the accessories will appear here.",
  profiles: "Profiles",
  software: "Software",
  exception_user_for_group:
    "You can add exceptions to this user later, after creation.",
  group_title_onboarding: "Select a autopilot to assign configurations",
  software_will_be_set: "software will be set",
  profiles_will_be_set: "profiles will be set",
  no_profiles: "No profiles",
  no_software: "No software",
  searchInProfiles: "Search in profiles",
  searchInSoftware: "Search in software",
  no_security_profiles: "No security profiles",
  no_software_profiles: "No software ",
  next: "Next",
  back: "Back",
  security_profiles: {
    tabs: {
      all: "All",
      trio_profiles: "Trio Profiles",
      custom: "Custom",
    },
    empty_state_title: "No Custom Profiles",
    empty_state_description:
      "Create Profile to restrict devices in your company",
    create_first_profile: "Create First Profile",
    table: {
      name: "Name",
      category: "Category",
      type: "Type",
      os: "OS",
      version: "Version",
      operation_system: "Operating system",
      device_ownership: "Ownership",
      assigned_to: "Assigned to",
      BYOD: "BYOD",
      CO: "Company-owned",
      COD: "Company-owned",
    },
  },
  new_user_created: "New user created!",
  new_user_created_description:
    "The user account will be activated and they will be able to use all the features. If you don't want to activate it now, please schedule an activation date.",
  activation_info: "Activation Information",
  active_now: "Active now",
  learn_more: "Learn more",
  schedule_activation: "Schedule activation",
  edit: "Edit",
  save: "Save",
  activate_description: "Activate the user account now or set activation date",
  schedule_activation_description:
    "Activate the user account immediately or schedule it for a specific date.",
  save_and_activate: "Save and create another",

  delivery_method: "Delivery method",
  in_office: "In office",
  in_office_description: "User get their devices in chosen office",
  deliver_user: "Deliver to user",
  deliver_user_description:
    "Add delivery information so we can track the delivery for you",
  tracking_number_placeholder: "Tracking Number",
  view: "View",
  delivery_method_inoffice_description: " choose the office location",
  delivery_method_mail_description:
    "Enter the tracking number you submitted with the service",

  onboarding_heading: "User Onboarding",
  onboarding_description:
    "To on board the users in your organizations, follow the instruction carefully.",

  // Navigation steps
  user_information: "User Information",
  group: "Autopilot",
  device_delivery: "Device Delivery",

  // Action buttons
  save_and_continue: "Save user & continue later",
  continue: "Continue",

  // Form sections
  basic_information: "Basic Information",
  first_name: "First Name",
  first_name_required: "First name is required",
  last_name: "Last Name",
  last_name_required: "Last name is required",
  password: "Password",
  password_required: "Password is required",
  email_address: "Email Address",
  email_address_required: "Personal Email is required",
  company_email_required: "Company Email is required",

  generate_business_email: "Do you want to generate a business email?",

  // Personal Information Section
  profile_photo_description_onboarding: "Drag or choose a profile photo",
  postal_code: "Postal code",
  contact: "Contact",
  phone_number: "Phone number",
  emergency_phone_number: "Emergency phone number",
  birthday: "Birthday",
  date_of_birth: "Date of birth",
  n_a: "N/A",
  change_password: "Change password",

  // Employment Information Section
  employee_id: "Employee ID",
  job_title: "Job title",
  employee_type: "Employee type",
  manager: "Manager",
  employeeId_description:
    "Employee ID is a unique identifier of Trio’s user identifier. It is not required.",

  // Misc
  optional: "optional",
  completeness: "Completeness",

  //accordian
  main_information: "Main information",
  employment_information: "Employee information",

  save_and_create_another: "Save and create another",

  employee_info: "Employee information",
  offboardTitle: "Offboard",
  offboardTitleBulk: "Off-board user quickly",
  users: "Users",
  offboardTitleBulkContent:
    "Note that in this offboarding method all profiles and configuration and devices will be unassign.",
  offboardConfirm: "To confirm, enter ",
  enterConfirmText: "Enter...",
  confirmText: "Off-board",

  immediateOffboard: "Immediate off-boarding",
  scheduleOffboard: "Schedule off-boarding",
  choose_method_device: "Choose a method for devices",
  choose_method_device_content: "Choose a method for devices",
  offboarding_methond: "Off-boarding method",
  offboarding_methond_content: "Choose a method for off-boarding",
  start: "Start",
  scheduled_time: "Scheduled time",
  offboarding_started: "Offboarding started",
  start_time: "Start time",
  offboarding_status: "Status",
  offboarding_wipe: "Wipe",
  offboardingMethod: "Off-boarding method",
  offboarding_unassign: "Unassign",
  schedule_time: "Schedule time",
  offboarding_wipe_content:
    "Completely wipes all data and profiles, returning the device to factory settings.",
  offboarding_unassign_content:
    "Unenrolls the device from MDM but leaves all data intact.",
  time: "Time",
  no_device_assigned: "No device assigned",
  deleteUser: "Delete",
  delete_title: "Unassign user",
  delete_description: "Do you want to unassign the user from the autopilot?",
  delete_subDescription: "Main Assets:",
  delete_warning: "This action cannot be undone.",
  delete_delete: "Unassign",
  delete_cancel: "Cancel",
  unable_delete_title: "Unable to delete!",
  unable_delete_description:
    "You can't delete autopilot that contain primary assets assigned to them",
  unable_main_assets: "Main Assets:",
  unable_delete_warning:
    "To delete a autopilot, remove all assets from it first",
  success_delete_title: "User unassigned!",
  success_delete_description: "The user has been successfully unassigned.",
  delete_description_without_device:
    "Do you want to unassign the user from autopilot permanently?",
  delete_warning_without_device: "All settings will be removed from the user",
  quick_offboard: "Quick offboard",
  action: "Actions",
};
